
import React from 'react';
import { motion } from 'framer-motion';

interface LogoProps {
  className?: string;
  showGlow?: boolean;
}

const Logo: React.FC<LogoProps> = ({ className = "w-48", showGlow = false }) => {
  return (
    <div className={`relative flex flex-col items-center ${className}`}>
       {/*DEEJAY Line */}
      <div className="flex items-center justify-center w-full space-x-3 mb-[-2px]">
        <div className="h-[1px] flex-grow bg-gold/50 rounded-full" />
        <span className="text-gold font-bold tracking-[0.4em] text-[0.55em] uppercase opacity-80">DEEJAY</span>
        <div className="h-[1px] flex-grow bg-gold/50 rounded-full" />
      </div>

      <img src="/images/logo-saff.png"></img>
      {/* SAFF Text */}
      {/*<div className="relative">*/}
      {/*  <h1 className="text-white font-black tracking-[-0.05em] text-4xl md:text-5xl lg:text-7xl flex items-baseline leading-none font-serif">*/}
      {/*    S*/}
      {/*    <span className="relative inline-block text-gold">*/}
      {/*      A*/}
      {/*      <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-[60%] h-[2px] bg-gold/30 rounded-full" />*/}
      {/*    </span>*/}
      {/*    FF*/}
      {/*  </h1>*/}
      {/*</div>*/}

       {/*Signature Glow */}
      {showGlow && (
        <motion.div 
          initial={{ opacity: 0, scaleX: 0 }}
          animate={{ opacity: 1, scaleX: 1 }}
          transition={{ delay: 1, duration: 1.5 }}
          className="absolute -bottom-10 left-1/2 -translate-x-1/2 w-[140%] h-8 bg-gold/20 blur-2xl rounded-full"
        />
      )}
      {showGlow && (
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 1 }}
          className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-1/3 h-[1px] bg-gold/50 shadow-[0_0_20px_rgba(212,175,55,0.5)]"
        />
      )}
    </div>
  );
};

export default Logo;
